module.exports = __webpack_public_path__ + "img/todo.671f0d01.jpg";